import Fullscreen from './fullscreen.vue'
export default Fullscreen



// WEBPACK FOOTER //
// ./src/components/main/components/fullscreen/index.js